export default __webpack_public_path__ + "static/media/Pretendard-Thin.348f2471.woff";